import { render, staticRenderFns } from "./Fail.vue?vue&type=template&id=6ac1e574&scoped=true&"
import script from "./Fail.vue?vue&type=script&lang=ts&"
export * from "./Fail.vue?vue&type=script&lang=ts&"
import style0 from "./Fail.vue?vue&type=style&index=0&id=6ac1e574&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac1e574",
  null
  
)

export default component.exports